import 'bootstrap';
import 'popper.js';

$( ( $ )  => {
    // check for link clicks in .post-type .is-locked
    $( '.is-locked.lessonmaterial a, .is-locked.lesson a, .is-locked.download' ).on( 'click', function( e ) {
        e.preventDefault();

        // open modal modal_post_locked
        $( '#modal_post_locked' ).modal( 'show' );
    });
});